import * as React from "react";
const SvgFiRrStars = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-stars_svg__a)">
      <path
        fill="#062147"
        d="M14.4 24a2.8 2.8 0 0 1-1.67-.56l-2.736-2.167-2.713 2.145a2.82 2.82 0 0 1-3.35.035A2.78 2.78 0 0 1 2.9 20.3l.945-3.276-2.68-1.918A2.82 2.82 0 0 1 2.821 10h3.432L7.3 6.606a2.835 2.835 0 0 1 5.38-.006l1.052 3.4h3.433a2.821 2.821 0 0 1 1.666 5.1l-2.677 1.923.947 3.31a2.77 2.77 0 0 1-1.044 3.123A2.83 2.83 0 0 1 14.4 24m-4.41-5a1 1 0 0 1 .62.215l3.332 2.634a.76.76 0 0 0 .942-.018.77.77 0 0 0 .3-.918l-1.146-4.014a1 1 0 0 1 .378-1.085l3.24-2.33a.82.82 0 0 0-.49-1.485H13a1 1 0 0 1-.955-.7l-1.273-4.1a.823.823 0 0 0-1.56.01L7.946 11.3a1 1 0 0 1-.955.7h-4.17a.822.822 0 0 0-.485 1.486l3.245 2.324a1 1 0 0 1 .38 1.09l-1.153 3.985a.784.784 0 0 0 .292.947.81.81 0 0 0 .967 0l3.306-2.611a1 1 0 0 1 .62-.22zM20 7.146l1.481 1.089a.809.809 0 0 0 1.25-.9l-.572-1.771 1.506-1.1A.81.81 0 0 0 23.188 3h-1.854l-.563-1.756a.813.813 0 0 0-1.542 0L18.666 3h-1.853a.81.81 0 0 0-.478 1.463l1.506 1.1-.572 1.77a.79.79 0 0 0 .3.907.8.8 0 0 0 .953-.005z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-stars_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrStars;
